import { API_V1 } from '@front-app/services/api';

export enum EventRoleRequest {
	ACCEPT = 'accept',
	IGNORE = 'ignore', // actually "leave"
	DECLINE = 'decline', // decline invitation
	TERMS = 'terms',
}

export function updateEventMemberRole(eventId: string, action: EventRoleRequest): Promise<void> {
	return API_V1.put(`/event/${eventId}/member?action=${action}`);
}
